// extracted by mini-css-extract-plugin
module.exports = {"swiper":"image-slider_swiper__vsGBD","slider-block":"image-slider_slider-block__G4ZVj","swiper-buttons":"image-slider_swiper-buttons__Mkxjx"};